module.exports = __webpack_public_path__ + "static/assets/fa535a2ffebfa48a0ad294c5e1814fc5.ttf";